import { render } from "./SubgrupoList.vue?vue&type=template&id=54d4587e&scoped=true"
import script from "./SubgrupoList.vue?vue&type=script&lang=js"
export * from "./SubgrupoList.vue?vue&type=script&lang=js"

import "./SubgrupoList.vue?vue&type=style&index=0&id=54d4587e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d4587e"]])

export default __exports__